export default __webpack_public_path__ + "static/media/MH-SHIRT-FRONT.97175672.png";